<template>
  <div>
    <div class="bg_img">
      <!-- <img src="./assets/banner_bg.png"/> -->
    </div>
    <header>
      <div class="header_content">
        <div class="header_logo">
          <img :src="require('@/assets/img/logo.png')" />
        </div>
        <div class="header_menu">
          <el-menu
            :default-active="'1'"
            class="el-menu-demo"
            mode="horizontal"
          >
            <el-menu-item index="1"><a href="/" class="header_href">首页</a></el-menu-item>
            <el-menu-item index="2"><a  class="header_href" @click.prevent="$emit('scrollTo','index_section_service')">服务保障</a></el-menu-item>
            <el-menu-item index="3"><a class="header_href"  @click.prevent="$emit('scrollTo','index_category')">服务类目</a></el-menu-item>
            <el-menu-item index="4"><a  class="header_href"  @click.prevent="$emit('scrollTo','index_group')">优秀案例</a></el-menu-item>
            <el-menu-item index="5"><a  class="header_href" @click.prevent="$emit('scrollTo','index_process')">服务流程</a></el-menu-item>
          </el-menu>
        </div>
        <div class="header_login">
          <el-button type="primary" class="header_login_brand" @click="$emit('mlogin','brand')">需求方登录</el-button>
          <el-button type="primary"  plain class="header_login_service" @click="$emit('mlogin','service')">服务方登录</el-button>
        </div>
      </div>
    </header>
    <!-- 品牌login start  -->
    <el-dialog
      :visible.sync="visible_brand_tmp"
      width="680px"
      custom-class="login_modal"
      @close="changVisiableBrand"
      :title="diaTitle"
    >
      <header class="modal_header">
        <img :src="require('@/assets/img/logo.png')" />
        <p>企业营销AIGC创意解决方案</p>
      </header>
      <el-form
        class="modal_content"
        :model="loginRuleForm"
        :rules="loginRules"
        ref="loginRuleForm"
        label-width="100px"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginRuleForm.username"
            placeholder="请输入用户名"
            maxlength="30"
            @keyup.enter.native="submitForm('loginRuleForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginRuleForm.password"
            placeholder="请输入密码"
            show-password
            maxlength="30"
            @keyup.enter.native="submitForm('loginRuleForm')"
          ></el-input>
        </el-form-item>
        <el-form-item prop="code">
          <div class="code">
            <el-input
              v-model="loginRuleForm.code"
              placeholder="请输入验证码"
              maxlength="4"
              @keyup.enter.native="submitForm('loginRuleForm')"
            ></el-input>
            <img :src="yzmstr" @click="getYzmcode" v-if="loginRuleForm.yzmid"/>
            <span v-else> 验证码加载中</span>
          </div>
        </el-form-item>

        <el-button
          class="modal_content_btn_submit"
          type="primary"
          @click="submitForm('loginRuleForm')"
          :disabled="form_disabled"
        >{{ diaTitle }}</el-button>
        <div style="cursor: pointer ;margin-top:10px;color: #3a8ee6" @click.prevent="$emit('mlogin','noaccount')">没有账号？去注册</div>
      </el-form>
    </el-dialog>
    <!-- 品牌login end  -->
  </div>
</template>
<script>
/* eslint-disable */
import axios from 'axios'
import Cookies from 'js-cookie'
import * as commfun from "@/common/common.js"
// import {ajaxPost} from "../common/common";

export default {
  props: ["visible_brand","visible_type"],
  data:function (){
    return {
      diaTitle: "需求方登录",
      visible_brand_tmp: this.visible_brand,
      yzmstr: '',
      form_disabled:false,
      loginRuleForm: {
        username: "",
        password: "",
        code: "",
        yzmid:"",
        yzmkey:"",
        visible_type:""
      },
      loginRules: {
        username: [
          {required: true, message: "请输入用户名", trigger: "blur"},
          {
            pattern: /^[a-zA-Z0-9]+$/,
            message: "请输入英文或数字",
            trigger: "blur",
          },
        ],
        password: [
          {required: true, message: "请输入密码", trigger: "blur"},
        ],
        code: [
          {required: true, message: "请输入验证码", trigger: "blur"},
          {
            pattern: /^[a-zA-Z0-9]+$/,
            message: "请输入英文或数字",
            trigger: "blur",
          },
        ],
      },
    }
  },
  watch:{
    visible_brand:function(newData){
      this.visible_brand_tmp = newData
     // console.log("newdata"+newData)
      if(newData==true){ //获取验证码
        this.getYzmcode()
      }
      //变更title
      if(this.visible_type=="brand"){
        this.diaTitle = "需求方登录"
      }else if(this.visible_type=="server"){
        this.diaTitle = "服务方登录"
      }
    }
  },
  methods: {
    changVisiableBrand(){
     this.$emit('mlogin_clean','brand')
    },
    submitForm(formName){
      var selfthis = this
      var isvalid=true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          //return false;
          isvalid = false
        }
      });
      if(!isvalid) return false

      var url = "/api/api/login/tologin"
      selfthis.form_disabled=true

      var postdata={}
      selfthis.loginRuleForm['visible_type'] = selfthis.visible_type
      for(let k in selfthis.loginRuleForm){
        postdata[k]=selfthis.loginRuleForm[k]
      }
      postdata.password = commfun.encryptData(selfthis.loginRuleForm.password,selfthis.loginRuleForm.yzmkey)
      postdata.code = commfun.encryptData(selfthis.loginRuleForm.code,selfthis.loginRuleForm.yzmkey)
      postdata.visible_type = commfun.encryptData(selfthis.loginRuleForm.visible_type,selfthis.loginRuleForm.yzmkey)
      console.log("code:start:"+selfthis.loginRuleForm.code+":end")
      //console.log("decode:"+commfun.decryptData(postdata.code,selfthis.loginRuleForm.yzmkey)+"end")
      selfthis.form_disabled =true
      commfun.ajaxPost(selfthis,url,postdata,function (selfthis,data){
        console.log(data)
        Cookies.set('token', data.tokenstr)
        Cookies.set('userName', data.userName)
        Cookies.set('userId', data.userId)
        Cookies.set('telphone', data.telphone)
        Cookies.set('name', data.name)
        Cookies.set('type', data.type)
        if(data.type==1){
          window.location.href="/goods"
        }else if(data.type==2 || data.type==3){
          window.location.href="/servicecaselist"
        }
        return true
      },function (selfthis,dataError){
        selfthis.form_disabled = false
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })


    },//end submitForm
    getYzmcode(){  //获取验证码
      var selfthis = this
      var url = "/api/api/login/yzm"
      var postdata = {}
      commfun.ajaxPost(selfthis,url,postdata,function (selfthis,data){
        selfthis.yzmstr = data.image
        selfthis.loginRuleForm.yzmid=data.id
        selfthis.loginRuleForm.yzmkey = data.yzmkey
        return true
      },function (selfthis,dataError){
        commfun.showMessage(selfthis,'warning',"错误："+dataError.msg)
      })

    },//end

  }
}
</script>




// WEBPACK FOOTER //
// src/components/Header.vue